import React, { useEffect, useState } from 'react';

import { SERVER_URL } from '../../config';

import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { fetchCertData } from '../../services/certService'

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import MainImageCard from '../../components/Card/MainImageCard';
import BasicImgCard from '../../components/Card/BasicImgCard';
import { isMobile } from '../../config';

import S from './CompanyPage.module.css'

const CertListPage = () => {

  const [cert, setCert] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  useEffect(() => {
    const fetchCertListData = async () => {
      const certData = await fetchCertData(null);
      setCert(certData);
    };
    fetchCertListData();
  }, [])

  return (
    <div>
      <HeaderComponents pageKey="company" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="company" />
        </div>
        <div className='com-content-wrap mt-150'>
          <div className='mb-50 mt-50' id={S.certListWrap} style={{minHeight:'650px'}}>
          {isMobile() ? (
            <>
              {cert.map((item, index) => (
                <MainImageCard 
                  key={index} 
                  imgPath={SERVER_URL + item.CT_THUMBNAIL_PATH}
                  title={item.CT_TITLE}
                  wrapClass={'cert-card-div'}
                  imgClass={'cert-card-img'}
                  titleClass={'cert-card-title'}
                />
              ))}
            </>
          ) : (
            <>
              {cert.map((item, index) => (
                <BasicImgCard 
                  key={index}
                  imgPath={SERVER_URL + item.CT_THUMBNAIL_PATH}
                  title={item.CT_TITLE}
                  wrapClass={'ctListDiv'}
                />
              ))}
            </>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertListPage;
